<template>
  <div class="project-downloads">
    <div class="has-text-weight-bold has-text-left-tablet" id="downloadButtons">
      <a
        class="button is-rounded is-primary is-uppercase has-text-weight-bold is-size-7 download-button"
        @click="download('teacher-downloads')"
        v-if="files['teacher-downloads']"
      >
        <span class="icon is-small is-medium">
          <i class="fas fa-cloud-download-alt fa-lg"></i>
        </span>
        <span v-t="'teachers-material'" class="download-text"></span>
        <span class="icon is-small" v-if="downloading['teacher-downloads']">
          <i class="fas fa-circle-notch fa-spin"></i>
        </span>
      </a>
      <a
        class="button is-rounded is-primary is-uppercase has-text-weight-bold is-size-7 download-button"
        @click="download('student-downloads')"
        v-if="files['student-downloads']"
      >
        <span class="icon is-medium">
          <i class="fas fa-cloud-download-alt fa-lg"></i>
        </span>
        <span v-t="'students-material'" class="download-text"></span>
        <span class="icon is-small" v-if="downloading['student-downloads']">
          <i class="fas fa-circle-notch fa-spin"></i>
        </span>
      </a>
    </div>
    <i18n path="download_info" tag="label" v-if="!isLoggedIn" class="is-size-6">
      <a target="_blank" :href="register_url">{{ $t("register_link") }}</a>
      <a @click="login">{{ $t("login_link") }}</a>
    </i18n>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { saveAs } from 'file-saver/FileSaver'
export default {
  props: ['files'],
  data () {
    return {
      downloading: {
        'teacher-downloads': false,
        'student-downloads': false
      },
      register_url: process.env.VUE_APP_REGISTER_URL
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    ...mapActions(['downloadFile', 'login']),
    download: function (fileType) {
      if (!this.isLoggedIn) {
        let obj = {
          title: this.$t('App.login_required_title'),
          message: this.$t('App.login_required_message'),
          customCloseBtnText: this.$t('App.close'),
          type: 'info'
        }
        return this.$Simplert.open(obj)
      }
      this.downloadFile({ data: { id: this.files[fileType][0].id } })
      this.downloading[fileType] = true
      let file = this.files[fileType][0]
      
      const link = document.createElement('a')
      const pieces = file.fileUrl.split("/");

      link.href = file.fileUrl
      document.body.appendChild(link)
      link.click()
      this.downloading[fileType] = false
      document.body.removeChild(link)
      
    }
  }
}
</script>

<style scoped>
.button {
  margin-top: 5px;
}
.project-downloads {
  padding: 1rem;
  padding-bottom: 0;
}
.download-button {
  padding: 1.5rem;
  height: 44px;
}
.download-text {
  padding-left: 1rem;
}
#downloadButtons {
  margin-bottom: 0.5rem;
}
</style>
